import {
  SHOW_POPUP,
  HIDE_POPUP,
  REMOVE_DATA,
  SET_DATA,
  SET_DATA_EDIT
} from "./actionTypes";

const INIT_STATE = {
  is_show: false,
    title: "",
    description: "",
    warning: false,
    error: false,
    success: false,
    data:[]
}

const settings = (state = INIT_STATE, action) => {
let payload = action.payload
  switch (action.type) {
    case SHOW_POPUP:
      return {
        is_show: true,
        title: action.payload.title,
        description: action.payload.description,
        warning: action.payload.warning,
        error: action.payload.error,
        success: action.payload.success,
        data:[]
      }

    case HIDE_POPUP:
      return {
        is_show: false,
        data:[]
      }

      case SET_DATA:
        return {
           data:state.data.find(s=>s.formatted_address ? s.formatted_address == payload.formatted_address : s.country_id == payload.country_id) ? state.data : [...state.data,payload]
        }
  
      case REMOVE_DATA:
        return {
          data:state.data.filter(s=>s.formatted_address ? s.formatted_address != payload.formatted_address : s.country_id != payload.country_id)
        }
        case SET_DATA_EDIT:
        return {
          data:payload
        }
    default:
      return state
  }
};

export default settings;
